import { BaseApiService } from "@mirage/services/BaseApiService";
import { ICommentService } from "@shared/publicportal/services/ICommentService";
import { CreateCommentRequest, GetPublicCommentsResponse, GetCommentsRequest, GetUserCommentsResponse, CreateCommentResponse } from "@shared/publicportal/contracts/Comments";

export class CommentsService extends BaseApiService implements ICommentService {
    constructor() {
        super("publicportal/comments");
    }

    async create(request: Omit<CreateCommentRequest, "user">): Promise<CreateCommentResponse> {
        const response = await this.httpInstance().post("/", request);
        return response.data;
    }

    async getPublicComments(paId: number): Promise<GetPublicCommentsResponse> {
        const response = await this.httpInstance().get(`/${paId}`);
        return response.data;
    }
    async getUserComments(request: Omit<GetCommentsRequest, "publicUserId">): Promise<GetUserCommentsResponse> {
        const response = await this.httpInstance().get(`/userComments/${request.paId}`);
        return response.data;
    }
}
